var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'customer-add'},"title":_vm.$t('menuitems.customer.text')}}),_c('List',{attrs:{"dataList":_vm.customerData,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'status', color: true}],"fields":[ ("code: " + (_vm.$t('customer.code'))), ("name: " + (_vm.$t('customer.name'))), ("type: " + (_vm.$t('customer.type'))), 
          ("phone_no_1: " + (_vm.$t('customer.phone-no'))), ("email: " + (_vm.$t('customer.email'))), ("status: " + (_vm.$t('property.status'))), ("address: " + (_vm.$t('customer.address')))],"deletes":[_vm.deleted, null],"edit":{link: 'customer-edit'},"view":{link: 'customer-view'},"more":{
          sub: [{
            name: 'customer.follow-up.text', icon:'bx bx-file', link: 'customer-followup', column: 'id'
          }]
        },"filter":{
          search: ['customers.code', 'customers.name', 'customers.name_en', 'customers.phone_no_1', 'customers.phone_no_2'],
          dropdown: [{
            title: 'customer.type',
            field: 'customers.type_id',
            data: this.typeData.data,
            width: 2
          }, {
            title: 'property.status',
            field: 'customers.customer_status_id',
            data: this.statusData.data,
            width: 2
          }]
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }